export default "__VITE_ASSET__e951fa8c__"